/**
 * Time in milliseconds to delay showing a tooltip that contains the full version of some truncated
 * text.
 */
export const TRUNCATED_TEXT_TOOLTIP_DELAY_MS = 300;
